// project-imports
import {
  GET_INSTRUCTOR_BEGIN,
  GET_INSTRUCTOR_SUCCESS,
  GET_INSTRUCTOR_FAILURE,
} from "../constants/actions";

// State variable initialization
export const initialState = {
  isLoading: false,
  error: null,
  instructorData: [],
};

const instructorReducer = (state = initialState, action) => {

  if (action.type === GET_INSTRUCTOR_BEGIN) {
    // Set loading state
    return {
      ...state,
      isLoading: action.payload,
      error: null,
    };
  }

  if (action.type === GET_INSTRUCTOR_SUCCESS) {

    // Update state with all instructor
    return {
      ...state,
      isLoading: false,
      instructorData: action.payload,
      error: null,
    };
  }

  if (action.type === GET_INSTRUCTOR_FAILURE) {
    // Set error state
    return {
      ...state,
      isLoading: false,
      error: action.payload,
    };
  }

  return state;

};

export default instructorReducer;
